import revive_payload_client_cTL8zNzOdP from "/src/node_modules/.pnpm/nuxt@3.8.1_@parcel+watcher@2.5.6_@types+node@18.19.130_encoding@0.1.13_eslint@9.39.4_jiti@2.6_7o7lxloeq4k6cwc5dvpkg6b4iq/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_ljXvm7E33F from "/src/node_modules/.pnpm/nuxt@3.8.1_@parcel+watcher@2.5.6_@types+node@18.19.130_encoding@0.1.13_eslint@9.39.4_jiti@2.6_7o7lxloeq4k6cwc5dvpkg6b4iq/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_dJIKbtuqAM from "/src/node_modules/.pnpm/nuxt@3.8.1_@parcel+watcher@2.5.6_@types+node@18.19.130_encoding@0.1.13_eslint@9.39.4_jiti@2.6_7o7lxloeq4k6cwc5dvpkg6b4iq/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_vJWzgjVh25 from "/src/node_modules/.pnpm/nuxt@3.8.1_@parcel+watcher@2.5.6_@types+node@18.19.130_encoding@0.1.13_eslint@9.39.4_jiti@2.6_7o7lxloeq4k6cwc5dvpkg6b4iq/node_modules/nuxt/dist/app/plugins/payload.client.js";
import plugin_vue3_AwayRfMDYQ from "/src/node_modules/.pnpm/@pinia+nuxt@0.5.1_magicast@0.5.2_typescript@6.0.3_vue@3.3.8_typescript@6.0.3_/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_VUUnUFci3E from "/src/build/.nuxt/components.plugin.mjs";
import prefetch_client_qO0rufYifl from "/src/node_modules/.pnpm/nuxt@3.8.1_@parcel+watcher@2.5.6_@types+node@18.19.130_encoding@0.1.13_eslint@9.39.4_jiti@2.6_7o7lxloeq4k6cwc5dvpkg6b4iq/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import sentry_client_config_e52bTCuwfV from "/src/build/.nuxt/sentry-client-config.mjs";
import element_plus_teleports_plugin_40SBZJXLIi from "/src/build/.nuxt/element-plus-teleports.plugin.mjs";
import element_plus_injection_plugin_dnbz6I2xD5 from "/src/build/.nuxt/element-plus-injection.plugin.mjs";
import chunk_reload_client_r1aKkegivd from "/src/node_modules/.pnpm/nuxt@3.8.1_@parcel+watcher@2.5.6_@types+node@18.19.130_encoding@0.1.13_eslint@9.39.4_jiti@2.6_7o7lxloeq4k6cwc5dvpkg6b4iq/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import navigation_client_163lFOOaJM from "/src/plugins/navigation.client.js";
import _0_lazyload_2M0jtSNhco from "/src/plugins/0.lazyload.js";
import _1_router_BOMnv70eEy from "/src/plugins/1.router.js";
import _2_axios_5mWHIFihQw from "/src/plugins/2.axios.js";
import _5_util_bZfGGzBcPs from "/src/plugins/5.util.js";
import _7_directive_U7v5FN2LhZ from "/src/plugins/7.directive.js";
import _8_cookies_NsOe93V34P from "/src/plugins/8.cookies.js";
import _9_util_client_CHjYRSBnwQ from "/src/plugins/9.util.client.ts";
import gsap_client_YCLjR5XmPz from "/src/plugins/gsap.client.ts";
import loading_client_uMbZhYCS7M from "/src/plugins/loading.client.ts";
import perf_client_VyDQFKjMGE from "/src/plugins/perf.client.js";
import sentry_client_KUbIQ4zdAO from "/src/node_modules/.pnpm/@sentry+nuxt@10.49.0_@opentelemetry+api@1.9.1_@opentelemetry+core@2.7.0_@opentelemetry+api@1._gpyntfulj2ufcxduwtdk4d3o3m/node_modules/@sentry/nuxt/build/module/runtime/plugins/sentry.client.js";
export default [
  revive_payload_client_cTL8zNzOdP,
  unhead_ljXvm7E33F,
  router_dJIKbtuqAM,
  payload_client_vJWzgjVh25,
  plugin_vue3_AwayRfMDYQ,
  components_plugin_VUUnUFci3E,
  prefetch_client_qO0rufYifl,
  sentry_client_config_e52bTCuwfV,
  element_plus_teleports_plugin_40SBZJXLIi,
  element_plus_injection_plugin_dnbz6I2xD5,
  chunk_reload_client_r1aKkegivd,
  navigation_client_163lFOOaJM,
  _0_lazyload_2M0jtSNhco,
  _1_router_BOMnv70eEy,
  _2_axios_5mWHIFihQw,
  _5_util_bZfGGzBcPs,
  _7_directive_U7v5FN2LhZ,
  _8_cookies_NsOe93V34P,
  _9_util_client_CHjYRSBnwQ,
  gsap_client_YCLjR5XmPz,
  loading_client_uMbZhYCS7M,
  perf_client_VyDQFKjMGE,
  sentry_client_KUbIQ4zdAO
]